const replacePaths = ['/authenticate', 'authenticate']

export function getNextLocationURL(path: string) {
  const next = replacePaths.reduce((acc, curr) => acc.replace(curr, ''), window.location.pathname)
  console.log({ next, pathname: window.location.pathname })
  if (next === '/' || !next) return path
  return `${path}?next=${encodeURIComponent(next)}`
}
